import { FacileBasePriceI } from "../api/request/Lead/Interfaces/DataInterface.response";

/**
 * Landing de Facile en el build native (28-oct-2026): el lead nace en el gateway
 * como cualquier organic, sin monolito. Estas piezas traducen los datos del token
 * de Facile y el preview de precio del gateway a lo que la landing ya pinta.
 */

/** Sexo del token con los valores del calculador ("Male"/"Female"), como el monolito. */
export const facileGender = (gender: string | undefined): string => {
  const value = (gender ?? "").trim().toLowerCase();
  if ("m" === value || "male" === value) return "Male";
  if ("f" === value || "female" === value) return "Female";
  return gender ?? "";
};

/**
 * Fecha de nacimiento del token en YYYY-MM-DD (la que acepta el gateway). Admite
 * YYYY-MM-DD, DD-MM-YYYY, con barras y con hora; lo que no reconoce lo deja tal
 * cual para que el gateway lo rechace.
 */
export const facileBirthDate = (date: string | undefined): string => {
  const value = (date ?? "").trim().slice(0, 10).replace(/\//g, "-");
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) return value.split("-").reverse().join("-");
  return date ?? "";
};

const isNumber = (value: unknown): value is number =>
  "number" === typeof value && Number.isFinite(value);

/**
 * Precios de la landing desde el preview native (`/organic/quote`): `price` y
 * `promotedPrice` son la tarifa (como los da el monolito, sin promoción) y
 * `firstYearMonthly` es lo que se paga el primer año con el cupón por defecto,
 * calculado por el gateway (no por el front). Sin precio (fuera de grid o
 * rechazado) todo a 0.
 */
export const facilePricesFromRate = (rate: any): FacileBasePriceI => {
  const rated = "RATED" === rate?.outcome;
  const monthly = rated && isNumber(rate.monthly) ? rate.monthly : 0;
  const regularMonthly =
    rated && isNumber(rate.regularMonthly) && rate.regularMonthly > monthly ? rate.regularMonthly : monthly;
  const yearly = rated && isNumber(rate.yearlyCents) ? rate.yearlyCents / 100 : 0;
  const regularYearly =
    rated && isNumber(rate.regularYearlyCents) && rate.regularYearlyCents / 100 > yearly
      ? rate.regularYearlyCents / 100
      : yearly;
  return {
    monthly: { price: regularMonthly, promotedPrice: regularMonthly },
    yearly: { price: regularYearly, promotedPrice: regularYearly },
    firstYearMonthly: monthly,
    discountBps: rated && isNumber(rate.discountBps) ? rate.discountBps : 0,
  };
};

/** Atribución de Facile: afiliado, con su referencia externa como campaña. */
export const facileAttribution = (externalReference: string | undefined) => ({
  utmSource: "facile",
  utmMedium: "affiliate",
  campaign: externalReference || "landing-facile",
});
